export enum AppointmentStatusInternal {

   scheduled,
   completed,
   cancelled,
   pending
}